enum SortEmployeeOption {
  Assigned = 1,
  Unassigned,
  Az,
  Za
}

export { SortEmployeeOption };
